const TrendsView = () => {
  return <div>TrendsView</div>;
};

export default TrendsView;
